import { sizes } from "@/js/sizes";
import gsap from "gsap/gsap-core";
// import gsap from "gsap/gsap-core";

export default {
	name: "VideoModule",
	data() {
		return {
			vidSrcEl: null,
			isMuted: false,
			vidSrc: String,
			boxesComp: null,
			vidContent: null,
			sizes: sizes,
			soundIcons: null,
			scaleBar1: 1,
			scaleBar2: 1,
			scaleBar3: 1,
			scaleBar4: 1,
			tl: null
		};
	},
	props: {
		module: {
			required: false,
		},
	},
	mounted() {
		this.resizeEv();
		this.reloadVid();
		this.setVidLoop()

		this.$refs.vidEl.onloadeddata = () => {
			this.bumpVideoOnNarrowDevices()
		}


		window.addEventListener("resize", this.resizeEv);
		window.addEventListener("scroll", this.handleScroll);

		this.soundIcons = document.querySelectorAll('.video_sound_bar')

		this.isMuted = !this.isMuted

		this.animBars()
	},
	methods: {
		animBars() {
			const yoyo = { yoyo: true, repeat: -1, repeatDelay: 0 }
			const origin = { transformOrigin: 'center' }

			gsap.timeline()
				.fromTo(this.soundIcons[0], { scaleY: 0.1, ...origin }, { scaleY: 1, duration: 0.8, ...yoyo })
				.fromTo(this.soundIcons[1], { scaleY: 0.1, ...origin }, { scaleY: 1, duration: 0.6, ...yoyo }, '-=0.3')
				.fromTo(this.soundIcons[2], { scaleY: 0.3, ...origin }, { scaleY: 1, duration: 0.62, ...yoyo })
				.fromTo(this.soundIcons[3], { scaleY: 0.3, ...origin }, { scaleY: 1, duration: 0.62, ...yoyo }, '-=0.7')
		},
		toggleVideoMute() {
			this.isMuted = !this.isMuted

			this.$refs.vidEl.muted = this.isMuted
			this.clickAnim(this.$refs.muteVideo)
		},
		setVidLoop() {
			this.$refs.vidEl.addEventListener('ended',
				function () {
					this.currentTime = 50.08
					this.play();
				}
			);
		},
		rewindVideo() {
			this.$refs.vidEl.currentTime = 1

			if (window.innerWidth < sizes.c) {
				gsap.fromTo(this.$refs.rewindVideo, { rotate: 0 }, { rotate: -360 })
			} else {
				this.clickAnim(this.$refs.rewindVideo)
			}

		},
		clickAnim(el) {
			gsap.timeline().to(el, { scale: 0.1, duration: 0.06 })
				.to(el, { scale: 1, duration: 0.06 })
				.set(el, { clearProps: 'transform' })
		},
		dimVolume() {
			const offset = 100
			const vol = 1 - (window.scrollY / (document.querySelector('.boxes').offsetTop - offset))
			if (vol < 0) return
			this.$refs.vidEl.volume = vol
		},
		nextentLogoOverlay() {
			if (this.$refs.vidContent.offsetTop < 0) {
				this.$refs.vidContent.style.transform = `translateY(${0 - this.$refs.vidContent.offsetTop}px)`
			} else {
				this.$refs.vidContent.style.transform = 'none'
			}
		},
		resizeEv() {
			this.determineVid();
			this.nextentLogoOverlay()
			this.bumpVideoOnNarrowDevices()
		},
		parallax() {
			const translateY = (-window.scrollY * 0.25).toFixed(2);
			requestAnimationFrame(() => {
				this.$refs.vidWrapper.style.transform = `translateY(${translateY}px)`;
			});
		},
		determineVid() {
			this.vidSrc =
				window.innerWidth > this.sizes.d
					? this.module.video_desktop.url
					: window.innerWidth > this.sizes.c
						? this.module.video_tablet.url
						: this.module.video_mobile.url;
		},
		reloadVid() {
			this.$refs.vidSrc.src = this.vidSrc;
			this.$refs.vidEl.load();
		},
		goToBoxes() {
			const nextSibling = this.$el.nextElementSibling;
			gsap.to(window, { scrollTo: nextSibling })
		},
		videoState() {
			const videoBottom = this.$refs.video.getBoundingClientRect().bottom + 30;

			if (videoBottom < 0) {
				this.$refs.vidEl.pause();
				this.$refs.video.style.visibility = 'hidden';
			} else {
				this.$refs.vidEl.play();
				this.$refs.video.style.visibility = 'visible';
			}
		},
		bumpVideoOnNarrowDevices() {
			const vid = this.$refs.vidEl.getBoundingClientRect()
			const windowHeight = window.innerHeight
			if (vid.height > windowHeight && windowHeight > sizes.b) {
				this.$refs.vidEl.style.transform = `translateY(${-(vid.height - windowHeight) / 2}px)`
			} else {
				this.$refs.vidEl.style.transform = 'none'
			}


		},
		handleScroll() {
			this.parallax();
			this.videoState();
			this.dimVolume()

			if (window.matchMedia('(max-width: 420px)').matches) {
				if (window.pageYOffset > 140) {
					document.querySelector('.video__content__scroll').style.opacity = 0;
				} else {
					document.querySelector('.video__content__scroll').style.opacity = 1;
				}
			} else {
				document.querySelector('.video__content__scroll').style.opacity = 1;
			}
		},
	},
	watch: {
		vidSrc() {
			this.reloadVid();
		},
		isMuted(next) {
			gsap.set(this.soundIcons, { opacity: next ? 0.5 : 1, clearProps: next ? 'opacity' : 'none' })

			if (next) {
				gsap.timeline()
					.set(this.soundIcons, { opacity: 0.5 })
					.fromTo(this.soundIcons[0], { attr: { y1: 12, y2: 24 } }, { duration: 0.5, attr: { y1: 17, y2: 20 } })
					.fromTo(this.soundIcons[1], { attr: { y1: 10, y2: 28 } }, { duration: 0.5, attr: { y1: 16, y2: 20 } }, '-=0.46')
					.fromTo(this.soundIcons[2], { attr: { y1: 12, y2: 24 } }, { duration: 0.5, attr: { y1: 16, y2: 20 } }, '-=0.42')
					.fromTo(this.soundIcons[3], { attr: { y1: 16, y2: 20 } }, { duration: 0.5, attr: { y1: 16, y2: 20 } }, '-=0.38')

			} else {
				gsap.timeline()
					.fromTo(this.soundIcons[0], { attr: { y1: 17, y2: 20 } }, { duration: 0.5, attr: { y1: 12, y2: 24 } })
					.fromTo(this.soundIcons[1], { attr: { y1: 13, y2: 18 } }, { duration: 0.5, attr: { y1: 10, y2: 28 } }, '-=0.46')
					.fromTo(this.soundIcons[2], { attr: { y1: 16, y2: 20 } }, { duration: 0.5, attr: { y1: 12, y2: 24 } }, '-=0.42')
					.fromTo(this.soundIcons[3], { attr: { y1: 16, y2: 20 } }, { duration: 0.5, attr: { y1: 16, y2: 20 } }, '-=0.38')
			}
		}
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.resizeEv);
		window.removeEventListener("scroll", this.handleScroll);
	},
};
